import { Component } from '@angular/core';

@Component({
    selector: 'app-bar-graph-table-header',
    templateUrl: './bar-graph-table-header.component.html',
    styleUrl: './bar-graph-table-header.component.css',
    standalone: false,
})
export class BarGraphTableHeaderComponent {
    isInfoMessageVisible: boolean = false;
}
